module.exports = __webpack_public_path__ + "img/5.895924f0.png";